import { call, put } from 'redux-saga/effects';

import { Api } from '../../api/api';
import { config } from '../../api/config';
import { actions } from '../actions';
import { ensureExportFilename } from '../download/download.helpers';

import { errorMessage } from '../../utils';

export function* getMonitoringSaga({ payload }) {
  try {
    yield put(actions.monitoring.setMonitoringLoadingAction(true));

    const data = yield call(Api.getMonitoringData, payload);

    yield put(actions.monitoring.setMonitoringAction(data));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.monitoring.setMonitoringLoadingAction(false));
  }
}

export function* getAvailabilityDevicesSaga() {
  try {
    const data = yield call(Api.getAvailabilityDevicesData);

    yield put(actions.monitoring.setAvailabilityDevices(data));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  }
}

export function* getAvailabilityDevicesByPeriodSaga({ payload }) {
  try {
    const data = yield call(Api.getAvailabilityDevicesByPeriodData, payload);

    yield put(actions.monitoring.setAvailabilityDevicesByPeriod(data));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  }
}

export function* getApplicationsSaga({ body }) {
  try {
    yield put(actions.monitoring.setApplicationsLoadingAction(true));

    const data = yield call(Api.getApplications, body);

    yield put(actions.monitoring.setApplicationsAction(data));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.monitoring.setApplicationsLoadingAction(false));
  }
}

export function* getDevicesSaga({ body: initialBody }) {
  try {
    yield put(actions.monitoring.setDevicesLoadingAction(true));

    const body = {
      ...initialBody,
      limit: config.DEFAULTS.recordsPerPage,
    };

    const { devices, header, count } = yield call(Api.getDevices, body);

    yield put(actions.monitoring.setDevicesAction(devices, header, count));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.monitoring.setDevicesLoadingAction(false));
  }
}

export function* getLogsSaga({ body: initialBody }) {
  try {
    yield put(actions.monitoring.setLogsLoadingAction(true));

    const body = {
      ...initialBody,
      limit: config.DEFAULTS.recordsPerPage,
    };

    const { logs, header, count } = yield call(Api.getLogs, body);

    yield put(actions.monitoring.setLogsAction(logs, header, count));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.monitoring.setLogsLoadingAction(false));
  }
}

export function* getScheduledActionLogsSaga({ body: initialBody }) {
  try {
    yield put(actions.monitoring.setScheduledActionLogsLoadingAction(true));

    const body = {
      ...initialBody,
      limit: config.DEFAULTS.recordsPerPage,
    };

    const { scheduled_action_logs, header, count } = yield call(
      Api.getScheduledActionLogs,
      body
    );

    yield put(
      actions.monitoring.setScheduledActionLogsAction(
        scheduled_action_logs,
        header,
        count
      )
    );
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.monitoring.setScheduledActionLogsLoadingAction(false));
  }
}

export function* exportLogsAsyncSaga({ filter, filename }) {
  try {
    yield put(actions.download.setXlsLoadingAction(true));
    const response = yield call(Api.exportLogsAsync, filter);

    const exportData = {
      ...response,
      status: response?.status || 'queued',
      filename: response?.filename || ensureExportFilename(filename),
    };

    yield put(actions.download.trackExportAction(exportData));
    yield put(actions.monitoring.setLogsExportIdentifierAction(exportData));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  } finally {
    yield put(actions.download.setXlsLoadingAction(false));
  }
}

export function* getDeviceAnalyticsSaga({ id }) {
  try {
    const data = yield call(Api.getDeviceAnalytics, id);

    yield put(actions.monitoring.setDeviceAnalyticsAction(data));
  } catch (e) {
    const msg = errorMessage(e);
    yield put(actions.error.setErrorAction(msg));
  }
}
